import PropTypes from 'prop-types';
import React from 'react';
import {StyledInvoicePreviewWithIcon} from './StyledInvoicePreviewWithIcon';
import ImagePreviewTooltip from '../../TransactionsPage/ImagePreviewTooltip';
import useInvoiceAttachmentPreview from '../../../../hooks/useInvoiceAttachmentPreview';
import {DocumentApprovedIcon} from '../../../../icons';

const InvoicePreviewWithIcon = ({
  icon,
  invoiceId,
  variant = 'backend',
  ...rest
}) => {
  const {
    showPreview,
    tooltipContent
  } = useInvoiceAttachmentPreview({variant});

  return (
    <ImagePreviewTooltip
      classNames={{root: 'image-preview-tooltip-overlay single unset-tooltip-width'}}
      title={tooltipContent}
    >
      <StyledInvoicePreviewWithIcon
        {...rest}
        onMouseEnter={() => showPreview(invoiceId)}
      >
        {icon || <DocumentApprovedIcon />}
      </StyledInvoicePreviewWithIcon>
    </ImagePreviewTooltip>
  );
}

InvoicePreviewWithIcon.propTypes = {
  invoiceId: PropTypes.string,
  variant: PropTypes.oneOf(['accounting', 'backend']),
}

export default InvoicePreviewWithIcon;
